import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import LogoSignIn from "./LogoSignIn";
import SigninForm from "./SigninForm";
import SignupForm from "./SignupForm";

const actionState = {
  signin: "signin",
  signup: "signup",
};

const AuthModal = () => {
  const { authModalOpen } = useSelector((state) => state.authModal);
  const dispatch = useDispatch();

  const [action, setAction] = useState(actionState.signin);

  useEffect(() => {
    if (authModalOpen) setAction(actionState.signin);
  }, [authModalOpen]);

  const handleClose = () => dispatch(setAuthModalOpen(false));
  const switchAuthState = (state) => setAction(state);

  return (
    <>
      {/* Modal Overlay */}
      {authModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
          onClick={handleClose}
        >
          {/* Modal Container */}
          <div
            className="relative w-full max-w-[400px] lg:max-w-lg bg-black rounded-lg shadow-lg p-6 border border-redlight m-0 lg:m-0"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            {/* Close button (optional) */}
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-white hover:text-gray-700 hover:bg-white rounded-full w-6"
            >
              &times;
            </button>

            {/* Modal Content */}
            <div className="text-center mb-8">
              <LogoSignIn />
            </div>

            {action === actionState.signin && (
              <SigninForm
                switchAuthState={() => switchAuthState(actionState.signup)}
              />
            )}

            {action === actionState.signup && (
              <SignupForm
                switchAuthState={() => switchAuthState(actionState.signin)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AuthModal;
